<div class="a-textarea"
  [class.gray-bg]="grayBg"
  [class.is-optional]="isOptional"
  [class.is-disabled]="isDisabled || control.disabled">
  <div class="a-textarea__optional" *ngIf="isOptional">Optional</div>
  <textarea
    placeholder=" "
    [readonly]="isDisabled"
    [formControl]="control"
    [class.has-error]="control.invalid && isSubmitted"
    (blur)="checkSave()">
  </textarea>
  <label>{{ label }}</label>
</div>